module.exports = __webpack_public_path__ + "img/furnitureshop-carousel.844c1826.png";